var getHashQueryParams = require('../utils/get-hash-query-params')
var assign = require('lodash').assign

module.exports = Em.Route.extend({
    userOrganizations: Ember.inject.service(),

    model: function(params, transition) {
        var queryParams = transition.queryParams
        var self = this
        var userOrganizations = this.get('userOrganizations')
        var hashQueryParams = getHashQueryParams()
        // The router only matches the pathname (e.g. "settings"), so any deep-link path encoded
        // after the hash (e.g. "#/organization/subscription") is translated into the `initialRoute`
        // query param instead - the same convention settings.js/umbrella-index.js already use to send
        // a module to a specific sub-route, and one the destination module's root route already
        // consumes (see useGetQueryFromEmberRoute). Restoring window.location.hash after the redirect
        // isn't reliable here since it races with that module's own root-path redirect.
        var hash = window.location.hash
        var hashQueryIndex = hash.indexOf('?')
        var hashPathPart = hashQueryIndex !== -1 ? hash.substring(0, hashQueryIndex) : hash
        var hashPath = hashPathPart === '#' || hashPathPart === '#/' ? '' : hashPathPart.replace(/^#/, '')
        var queryString = window.location.search
        var urlParams = new URLSearchParams(queryString)
        var couponFromUrl = urlParams.get('coupon')

        if (couponFromUrl) {
            queryParams.code = couponFromUrl
        }

        if (hashPath) {
            queryParams.initialRoute = hashPath
        }

        return userOrganizations.all()
            .then(function(organizations) {
                var organizationToActivate = userOrganizations.get('lastOrganizationUrl') || organizations[0].url

                if (organizations.length) {
                    try {
                        self.replaceWith(params.route, organizationToActivate, { queryParams: assign({}, queryParams, hashQueryParams) })
                    } catch(e) {
                        var url = '/' + organizationToActivate + '/' + params.route
                        self.replaceWith(url, { queryParams: assign({}, queryParams, hashQueryParams) })
                    }
                } else {
                    self.replaceWith('index')
                }
            })
    }
})
